import { DeepPartial } from 'ts-essentials';
import { IPresentationModel } from '@src/slide/domain/ui-model/element-modeles/Interface/presentation-model.interface';
import type { IPresentationDataModel } from '@tencent/slide-sdk-model';
import { SlideSizeConverter } from '@src/slide/domain/ui-model/converter/node-property/module-property/slide-size/slide-size-converter';
import {
    DataModelCommonConverter,
} from '@src/slide/domain/ui-model/converter/node-property/module-property/data-model-common/model-id-type-converter';

export class PresentationPropertyConverter {
    /**
     * 数据3.0转换接口
     * @param sdkData
     * @param uiData
     */
    public static convertPartialDataFromSdkToUi(
        sdkData: DeepPartial<IPresentationDataModel>,
        uiData: IPresentationModel,
    ): void {
        DataModelCommonConverter.convertPartialDataFromSdkToUi(sdkData, uiData);
        if (sdkData.slideList?.length !== undefined) {
            uiData.slideCount = sdkData.slideList.length;
        }

        if (sdkData.props?.sldSz !== undefined) {
            SlideSizeConverter.convertPartialDataFromSdkToUi(sdkData.props.sldSz, uiData.props);
        }

        // 起始页码（-1为用户编辑过程中清空文本框的场景，此时文本框通过sdk原始数据判定显示为空，而页面其他地方显示为1）
        if (sdkData.props?.firstSlideNum === -1) {
            uiData.firstSlideNum = 1;
        } else {
            uiData.firstSlideNum = sdkData.props?.firstSlideNum ?? 1;
        }
    }

    public static convertPartialDataFromUiToSdk(
        uiData: DeepPartial<IPresentationModel>,
        sdkData: IPresentationDataModel,
    ): void {}
}
